import { useQuery } from '@tanstack/react-query';

import { siteApi } from '@api';

// Query keys
export const siteKeys = {
  all: ['site'] as const,
  config: () => [...siteKeys.all, 'config'] as const,
};

// Get site config
export const useSiteConfig = () => {
  return useQuery({
    queryKey: siteKeys.config(),
    queryFn: () => siteApi.getConfig(),
    staleTime: 1000 * 60 * 30, // 30 minutes - config rarely changes
  });
};
